// extracted by css-extract-rspack-plugin
export default {"tableHeader":"tableHeader-YFSFur","left":"left-qGjx_y","right":"right-w_xpB8"};